// src/stores/zkpaStore.ts
import { create } from "zustand";
import type { ZKPAKeyState } from "@/shared/lib/crypto/types";

interface ZKPAStore {
  keyState: ZKPAKeyState;
  setKeyState: (state: ZKPAKeyState) => void;
}

export const useZKPAStore = create<ZKPAStore>(set => ({
  keyState: { status: "uninitialized" },
  setKeyState: (keyState) => set({ keyState }),
}));
